import React from "react";
import PageTitle from "../../components/shared/PageTitle";
// import PageHeadline from "../../components/shared/PageHeadline";
import "../../registration.css";
import { useTranslation } from "react-i18next";
import { isAuthenticated } from "../../lib/api";

import axios from "axios";

export default function Registration() {
    const { i18n, t } = useTranslation();
    const lang = i18n.language.toUpperCase();

    const [version, setVersion] = React.useState(null);
    const isAuth = isAuthenticated();
    if (!isAuth) {
        window.location.href = "/login";
    }
    // eslint-disable-next-line no-unused-vars
    const [isRegistrationOpen, setIsRegistrationOpen] = React.useState(true);

    // const [showCouponText, setShowCouponText] = React.useState(true);

    // const getQtyFromHash = () => {
    //     const hash = window.location.hash;
    //     const queryIndex = hash.indexOf("?");

    //     console.log('test', queryIndex)

    //     if (queryIndex !== -1) {
    //         const queryString = hash.substring(queryIndex + 1);
    //         const params = new URLSearchParams(queryString);
    //         return params.get("qty");
    //     }
    //     return null;
    // };

    // React.useEffect(() => {
    //     window.addEventListener('hashchange', () => {
    //         let currentQty = getQtyFromHash();

    //         if (Number(currentQty) === 3) {
    //             setShowCouponText(true);
    //         } else {
    //             setShowCouponText(false);
    //         }
    //     });

    //     return () => {
    //         window.removeEventListener('hashchange', () => { });
    //     }
    // }, [])

    React.useEffect(() => {
        const fetchData = async () => {
            try {
                const axres = await axios.get('https://bandoeng10k-mailer.vercel.app/api/check-version', {
                    timeout: 10000
                });
                console.log(axres.data.version.integrator.wordpress.script);
                setVersion(axres.data.version.integrator.wordpress.script);
            } catch (error) {
                console.error(error);
                setVersion('latest');
            }
        }

        fetchData();
    }, []);

    React.useEffect(() => {
        if (version && isRegistrationOpen) {
            console.log(`current version => ${version}`);

            const jquery = document.createElement("script");
            const script = document.createElement("script");

            jquery.src = "https://code.jquery.com/jquery-3.2.1.min.js";
            jquery.async = true;

            script.src = `https://www.steelytoe.com/static/steelyreg.${version}.min.js`;
            script.async = true;

            script.onload = () => {
                const searchParams = new URLSearchParams(window.location.search);
                const invoiceId = searchParams.get('invoiceId');
                console.log('invoiceId', invoiceId);
                if (invoiceId) {
                    window.location.replace(`/registration#!/invoice/${invoiceId}`);
                }
            };

            document.body.appendChild(jquery);
            document.body.appendChild(script);

            return () => {
                document.body.removeChild(jquery);
                document.body.removeChild(script);
            };
        }
    }, [isRegistrationOpen, version]);

    return (
        <div className="bg-primary">
            {/* <div className="relative min-h-[240px] lg:min-h-[300px] bg-bgBannerPage bg-contain md:bg-cover bg-no-repeat top-[86px] md:top-[109px] 2xl:top-[136px] flex justify-center items-center">
                <PageHeadline title={t("registrationTitle")} isRegistration />
            </div> */}
            <div className="relative">
                <PageTitle title={t("registrationTitle")} subtitle={t("registrationGroupOf3Subtitle")} />
                {/* <PageTitle title={t("registrationClosedTitle")} /> */}
            </div>
            <div className="relative mt-4 sm:mt-16 md:mt-32 bg-primary 2xl:px-0 md:px-14 px-4 md:pt-24 pb-36 md:pb-96">
                {/* {showCouponText && <div className="mx-auto w-full text-center pb-12"><span className="text-base font-poppins italic text-white" dangerouslySetInnerHTML={{ __html: t("registrationCoupon") }} /></div>} */}
                <div className="bg-primary min-h-screen h-full container mx-auto w-full font-poppins px-4">
                    {version !== 'latest' && version !== null && <link
                        rel="stylesheet"
                        media="all"
                        href={`https://www.steelytoe.com/static/steelyreg.${version}.css`}
                    />}
                    <style jsx>
                        {
                            `
                                #steelytoeRegContainer > h3 {
                                    padding-top: 1rem;
                                }
                                .pure-input-1, .pure-form input[type="text"], .pure-form input[type="password"], .pure-form input[type="email"], .pure-form input[type="url"], .pure-form input[type="date"], .pure-form input[type="month"], .pure-form input[type="time"], .pure-form input[type="datetime"], .pure-form input[type="datetime-local"], .pure-form input[type="week"], .pure-form input[type="number"], .pure-form input[type="search"], .pure-form input[type="tel"], .pure-form input[type="color"], .pure-form select, .pure-form option, .pure-form textarea, .select2-container--default .select2-selection--single {
                                    background-color: white !important;
                                    color: black !important;
                                }
                                .pure-control-group label {
                                    font-family: Poppins !important;
                                }
                                .pure-control-group small {
                                    color: white !important;
                                }
                                .pure-control-group > input.pure-input-1 {
                                    font-family: Roboto !important;
                                }
                                .pure-control-group > select.pure-input-1 {
                                    font-family: Roboto !important;
                                }
                                .pure-control-group > select.pure-input-1 > option {
                                    font-family: Roboto !important;
                                }
                                .pure-input-1, .pure-form input[type="text"] {
                                    font-family: Roboto !important;
                                }
                                .pure-controls > button {
                                    background-color: #efca18 !important;
                                    color: white;
                                }
                                #steelytoeRegContainer > form.pure-form.couponContainer > button.pure-button {
                                    background-color: #efca18 !important;
                                    color: white !important;
                                }
                                #steelytoeRegContainer > form > input {
                                    background-color: white !important;
                                    color: black !important;
                                    font-family: Roboto !important;
                                }
                                span.select2-selection.select2-selection--single {
                                    display: flex !important;
                                    align-items: center !important;
                                    font-family: Roboto !important;
                                }
                                span.success {
                                    padding: .5rem 1rem !important;
                                    color: white;
                                    border-radius: 4px;
                                    background-color: #439647;
                                    display: inline-block;
                                    font-size: small;
                                }
                                span.error {
                                    padding: .5rem 1rem !important;
                                    color: white;
                                    border-radius: 4px;
                                    background-color: #ff0000;
                                    display: inline-block;
                                    font-size: small;
                                }
                                h4.dueNotify {
                                    padding: .5rem 1rem !important;
                                    color: white !important;
                                    border-radius: 4px;
                                    background-color: #ff0000;
                                    display: inline-block;
                                    font-size: small;
                                }
                                .pure-table tr:nth-child(even) td {
                                    background-color: #eccd38 !important;
                                    color: #009444 !important;
                                    font-weight: bold !important;
                                }
                                .pure-table tr:nth-child(odd) td {
                                    background-color: white !important;
                                    color: #009444 !important;
                                    font-weight: bold !important;
                                }
                                .pure-table th:first-child {
                                    background-color: #eccd38 !important;
                                    color: white !important;
                                }
                                .pure-table thead tr th {
                                    background-color: #eccd38 !important;
                                    color: white !important;
                                }
                                @media screen and (max-width: 768px) {
                                    .pure-table-horizontal td,
                                    .pure-table-horizontal th {
                                        padding: 4px 8px !important;
                                        font-size: 14px !important;
                                    }
                                }
                                .paymentButton .BNIVAInfo h3,
                                .paymentButton .BNIVAInfo ul > li,
                                .BNIVAInfo h3,
                                .BNIVAInfo ul > li {
                                    font-weight: bold !important;
                                }
                                .BNIVAInfo {
                                    padding-bottom: 2rem;
                                }
                                .BNIVAInfo h3 {
                                    padding-bottom: 1rem;
                                }
                                .BNIVAInfo h4 {
                                    padding-top: 1rem;
                                }
                                div.steelytoeErrorBox {
                                    border: solid 1px #fff;
                                    color: #fff;
                                    padding: 10px;
                                    margin-top: 7rem;
                                }
                                #steelytoeRegContainer .pure-button[payment-id] {
                                    margin-right: 1rem;
                                    min-height: 40px;
                                }
                                .pure-form legend {
                                    color: white !important;
                                    font-family: Poppins, sans-serif !important;
                                }
                                .pure-control-group > hr {
                                    display: none !important;
                                }
                                .pure-control-group small {
                                    color: #fff !important;
                                }
                                @media screen and (max-width: 48em) {
                                    .pure-form legend {
                                        background: #efc91a;
                                        color: #164481 !important;
                                        font-weight: bold;
                                        border-radius: 4px;
                                        padding: 8px 16px;
                                        margin-top: 1rem;
                                        margin-bottom: -1rem;
                                    }
                                }
                                @media screen and (min-width: 48em) {
                                    .pure-g {
                                        gap: 1rem;
                                        justify-content: space-between;
                                    }
                                    .pure-u-md-1-3, .pure-u-md-8-24 {
                                        width: calc(33.3333% - 1rem);
                                    }
                                    .pure-u-md-1-3 .pure-control-group input, .pure-u-md-8-24 .pure-control-group input {
                                        width: calc(100% - 21.5rem) !important;
                                    }
                                    .pure-u-md-1-3 .pure-control-group label, .pure-u-md-8-24 .pure-control-group label {
                                        width: calc(100% - 21.5rem) !important;
                                    }
                                    .pure-u-md-1-3 .pure-control-group select, .pure-u-md-8-24 .pure-control-group select {
                                        width: calc(100% - 21.5rem) !important;
                                    }
                                    .pure-u-md-1-3 .pure-control-group span.select2, .pure-u-md-8-24 .pure-control-group span.select2 {
                                        width: calc(100% - 21.5rem) !important;
                                    }
                                    .select2-container--default .select2-selection--single .select2-selection__arrow {
                                        height: 26px;
                                        position: absolute;
                                        top: 20px;
                                        right: 16px;
                                        width: 20px;
                                    }
                                    .pure-u-md-1-3 .pure-control-group .jerseyImage img, .pure-u-md-8-24 .pure-control-group .jerseyImage img {
                                        max-width: 38%;
                                    }
                                }
                                @media screen and (min-width: 64em) {
                                    .pure-g {
                                        gap: 1rem;
                                        justify-content: space-between;
                                    }
                                    .pure-u-md-1-3, .pure-u-md-8-24 {
                                        width: calc(33.3333% - 1rem);
                                    }
                                    .pure-u-md-1-3 .pure-control-group input, .pure-u-md-8-24 .pure-control-group input {
                                        width: calc(100% - 17rem) !important;
                                    }
                                    .pure-u-md-1-3 .pure-control-group label, .pure-u-md-8-24 .pure-control-group label {
                                        width: calc(100% - 17rem) !important;
                                    }
                                    .pure-u-md-1-3 .pure-control-group select, .pure-u-md-8-24 .pure-control-group select {
                                        width: calc(100% - 17rem) !important;
                                    }
                                    .pure-u-md-1-3 .pure-control-group span.select2, .pure-u-md-8-24 .pure-control-group span.select2 {
                                        width: calc(100% - 17rem) !important;
                                    }
                                    .select2-container--default .select2-selection--single .select2-selection__arrow {
                                        height: 26px;
                                        position: absolute;
                                        top: 20px;
                                        right: 16px;
                                        width: 20px;
                                    }
                                    .pure-u-md-1-3 .pure-control-group .jerseyImage img, .pure-u-md-8-24 .pure-control-group .jerseyImage img {
                                        max-width: 51%;
                                    }
                                }
                                @media screen and (min-width: 80em) {
                                    .pure-g {
                                        gap: 1rem;
                                        justify-content: space-between;
                                    }
                                    .pure-u-md-1-3, .pure-u-md-8-24 {
                                        width: calc(33.3333% - 1rem);
                                    }
                                    .pure-u-md-1-3 .pure-control-group input, .pure-u-md-8-24 .pure-control-group input {
                                        width: calc(100% - 11.5rem) !important;
                                    }
                                    .pure-u-md-1-3 .pure-control-group label, .pure-u-md-8-24 .pure-control-group label {
                                        width: calc(100% - 11.5rem) !important;
                                    }
                                    .pure-u-md-1-3 .pure-control-group select, .pure-u-md-8-24 .pure-control-group select {
                                        width: calc(100% - 11.5rem) !important;
                                    }
                                    .pure-u-md-1-3 .pure-control-group span.select2, .pure-u-md-8-24 .pure-control-group span.select2 {
                                        width: calc(100% - 11.5rem) !important;
                                    }
                                    .select2-container--default .select2-selection--single .select2-selection__arrow {
                                        height: 26px;
                                        position: absolute;
                                        top: 20px;
                                        right: 16px;
                                        width: 20px;
                                    }
                                    .pure-u-md-1-3 .pure-control-group .jerseyImage img, .pure-u-md-8-24 .pure-control-group .jerseyImage img {
                                        max-width: 66%;
                                    }
                                }
                                @media screen and (min-width: 85.375em) {
                                    .pure-g {
                                        gap: 1rem;
                                        justify-content: space-between;
                                    }
                                    .pure-u-md-1-3, .pure-u-md-8-24 {
                                        width: calc(33.3333% - 1rem);
                                    }
                                    .pure-u-md-1-3 .pure-control-group input, .pure-u-md-8-24 .pure-control-group input {
                                        width: calc(100% - 9rem) !important;
                                    }
                                    .pure-u-md-1-3 .pure-control-group label, .pure-u-md-8-24 .pure-control-group label {
                                        width: calc(100% - 9rem) !important;
                                    }
                                    .pure-u-md-1-3 .pure-control-group select, .pure-u-md-8-24 .pure-control-group select {
                                        width: calc(100% - 9rem) !important;
                                    }
                                    .pure-u-md-1-3 .pure-control-group span.select2, .pure-u-md-8-24 .pure-control-group span.select2 {
                                        width: calc(100% - 9rem) !important;
                                    }
                                    .select2-container--default .select2-selection--single .select2-selection__arrow {
                                        height: 26px;
                                        position: absolute;
                                        top: 20px;
                                        right: 16px;
                                        width: 20px;
                                    }
                                    .pure-u-md-1-3 .pure-control-group .jerseyImage img, .pure-u-md-8-24 .pure-control-group .jerseyImage img {
                                        max-width: 74%;
                                    }
                                }
                                @media screen and (min-width: 96.25em) {
                                    .pure-g {
                                        gap: 1rem;
                                        justify-content: space-between;
                                    }
                                    .pure-u-md-1-3, .pure-u-md-8-24 {
                                        width: calc(33.3333% - 1rem);
                                    }
                                    .pure-u-md-1-3 .pure-control-group input, .pure-u-md-8-24 .pure-control-group input {
                                        width: calc(100% - 4rem) !important;
                                    }
                                    .pure-u-md-1-3 .pure-control-group select, .pure-u-md-8-24 .pure-control-group select {
                                        width: calc(100% - 4rem) !important;
                                    }
                                    .pure-u-md-1-3 .pure-control-group span.select2, .pure-u-md-8-24 .pure-control-group span.select2 {
                                        width: calc(100% - 4rem) !important;
                                    }
                                    .select2-container--default .select2-selection--single .select2-selection__arrow {
                                        height: 26px;
                                        position: absolute;
                                        top: 20px;
                                        right: 16px;
                                        width: 20px;
                                    }
                                    .pure-u-md-1-3 .pure-control-group .jerseyImage img, .pure-u-md-8-24 .pure-control-group .jerseyImage img {
                                        max-width: 88%;
                                    }
                                }
                            `
                        }
                    </style>
                    {/* <script src="https://code.jquery.com/jquery-3.2.1.min.js"></script> */}
                    {/* <script src="https://www.steelytoe.com/static/steelyreg.0.42.116.min.js"></script> */}

                    {t("registration.announcement") && (
                        <div className="mb-8 p-4 md:p-5 rounded-xl bg-white flex items-start gap-3 shadow-md max-w-4xl mx-auto">
                            <svg
                                className="w-5 h-5 md:w-6 md:h-6 text-primary shrink-0 mt-0.5"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                            <span className="text-primary font-roboto text-sm md:text-base leading-relaxed">
                                {t("registration.announcement")}
                            </span>
                        </div>
                    )}

                    {isRegistrationOpen && <div id="steelytoeRegContainer" event-id={process.env.REACT_APP_EVENT_ID} lang={lang} className="">
                        <h3>Loading Registration Page, please standby ...</h3>
                    </div>}
                    <div className="flex items-center justify-center mt-4 text-sm invisible">
                        v{version}
                    </div>
                </div>
            </div>
        </div>
    );
}
